import type { FC, SVGProps } from "react";

const RepeatIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.05516 1.00958C7.27082 1.26118 7.24168 1.63996 6.99008 1.85561L5.42156 3.20006H7.59961C10.9133 3.20006 13.5996 5.88635 13.5996 9.20006C13.5996 12.5138 10.9133 15.2001 7.59961 15.2001C4.2859 15.2001 1.59961 12.5138 1.59961 9.20006C1.59961 8.74265 1.6509 8.29649 1.74829 7.86729C1.82162 7.54413 2.14304 7.34161 2.46619 7.41494C2.78935 7.48826 2.99187 7.80968 2.91854 8.13283C2.84079 8.4755 2.79961 8.8326 2.79961 9.20006C2.79961 11.851 4.94864 14.0001 7.59961 14.0001C10.2506 14.0001 12.3996 11.851 12.3996 9.20006C12.3996 6.54909 10.2506 4.40006 7.59961 4.40006H5.42156L6.99008 5.74451C7.24168 5.96016 7.27082 6.33894 7.05516 6.59054C6.83951 6.84213 6.46073 6.87127 6.20914 6.65561L3.40913 4.25561C3.27615 4.14162 3.19961 3.97521 3.19961 3.80006C3.19961 3.62491 3.27615 3.4585 3.40913 3.34451L6.20914 0.944506C6.46073 0.728852 6.83951 0.757989 7.05516 1.00958Z"
			fill="#7370FF"
		/>
	</svg>
);

export { RepeatIcon };
